<template>
  <el-main class="base-main">
    <div
      style="width:96%;margin: 0px auto 0;background-color: #fff;padding:20px;margin-top: 20px;"
    >
      <div id="printData">
        <div class="form-container">
          <span>表单内容</span>
        </div>
        <div class="form-content">
          <form v-if="html" data-vv-scope="custom-form">
            <online-form
              class="custom-form"
              :html="html"
              :data="data"
              :permission="permission"
              :isView="isView"
              ref="onlineForm"
              :isPrint="print"
            />
          </form>
        </div>
      </div>
      <div style="wdith:100%;text-align :center;padding-top:20px;">
        <el-button
          type="success"
          v-if="startFlow && startFlow!='false'"
          @click="start"
          :disabled="disabled"
        >发起流程</el-button>
        <el-button
          type="primary"
          icon="el-icon-printer"
          @click="printDetail()"
          :disabled="disabled"
        >打印</el-button>
        <el-button type="primary" @click="handleBoSave()" v-if="isShow && action != 'editDraft'" :disabled="disabled">保存</el-button>
        <el-button type="primary" @click="boSaveAndDelDraft" v-if="action === 'editDraft'" :disabled="disabled">保存并删除草稿</el-button>
        <!-- <el-button type="primary" @click="boSaveDraft" v-if="!id" :disabled="disabled">保存至草稿</el-button> -->
        <el-button type="error" @click="close">返回</el-button>
      </div>
    </div>
  </el-main>
</template>
<script>
import OnlineForm from "@/components/flow/OnlineForm.vue";
import form from "@/api/form.js";
import utils from "@/utils.js";
import req from "@/request.js";
import fUtils from "@/fUtils.js";
export default {
  name: "formContent",
  props: ["templateKey", "action"],
  data() {
    return {
      html: null,
      data: null,
      permission: null,
      isView: true,
      disabled: false,
      boAlias: "",
      id: "",
      startFlow: false,
      recordId:"",
      defKey: "",
      formKey: "",
      fillField: "",
      fillValue: "",
      print: false,
      isShow: true,
      tempAlias:""
    };
  },
  components: { OnlineForm },
  updated() {
    let result = window.location.href.split("?")[0].split("/");
    if(result[result.length - 1] == "get" || result[result.length - 2] == "get" ){
      this.isShow = false;
    }
    if (this.$route.query.isPrint) {
      this.printDetail();
    }
  },
  methods: {
    printDetail() {
      this.$route.query.isPrint=false;
      let url = window.location.href;
      let result = url.split("?")[0].split("/");
      if (!this.$route.query.isPrint && result[result.length - 1] == "edit") {
        this.print = true;
        this.$router.push({
          name: "onlineForm",
          params: {
            isPrint: true,
            permission: this.permission,
            html: this.html,
            data: this.data
          }
        });
      } else {
	      var str = "",styles = document.querySelectorAll('style,link');
	      for (var i = 0; i < styles.length; i++) {
		      str += styles[i].outerHTML;
	      }
	      var test=Print('#printData',
			      {'no-print':'top-btns-col no-print'}
	      );
	      var printData =test.dom.innerHTML;
	      //创建一个iframe在负像素位置
	      var w, doc, iframe = document.createElement('iframe'),
			      f = document.body.appendChild(iframe);
	      iframe.id = "myIframe";
	      iframe.setAttribute('style', 'position:absolute;width:0;height:0;top:-10px;left:-10px;');
	      w = f.contentWindow || f.contentDocument;
	      doc = f.contentDocument || f.contentWindow.document;
	      doc.open();
	      //把样式跟html字符串拼接输出给iframe
	      doc.write(str+printData);
	      doc.close();
	      //iframe渲染完成后,开启打印,并销毁iframe
	      iframe.onload = function(){
		      w.print();
		      setTimeout(function () {
			      document.body.removeChild(iframe)
		      }, 100);
	      };
        /*if (this.html) {
          if (document.getElementById("printData")) {
            document.body.innerHTML = document.getElementById(
              "printData"
            ).innerHTML;
            window.print();
            if (this.$route.query.isPrint) {
              this.$router.go(-1);
            }
            setTimeout(function() {
              location.reload();
            }, 200);
          }
        } else {
          setTimeout(() => {
            this.printDetail();
          }, 500);
        }*/
      }
    },
    //启动
    start() {
      utils
        .getOnlineFormData(true)
        .then(formDataStr => this.processStart(formDataStr))
        .catch(reason =>
          utils.handleGetFormDataReject(reason).then(() => this.processStart())
        );
    },
    processStart(formDataStr) {
      let data = { flowKey: this.defKey };
      if (formDataStr) {
        data.data = Base64.encode(formDataStr);
      }
      this.disabled = true;
      this.$store
        .dispatch("storeProcess/start", data)
        .then(() => {
          this.close(true);
        })
        .catch(() => {
          this.disabled = false;
        });
    },
    handleBoSave(delDraftId){
      window.app.$validator.validate().then(result=>{
        if(result){//校验通过
          this.boSave(delDraftId)
        }else{
          let msg = "";
          this.$validator.errors.items.forEach(error=>{
            let field;
            if(error.field.indexOf("-") != -1){
              field = error.field.split("-")[1];
            }else{
              field = error.field;
            }
            msg = msg + field + "," + error.msg + "<br/>"
          })
          this.$notify({
            dangerouslyUseHTMLString:true,
            title:'以下字段校验未通过，请检查',
            message:msg
          })
        }
      })
    },
    //保存
    boSave(delDraftId) {
      utils
        .getOnlineFormData(false)
        .then(formDataStr => {
          let data = {
            boAlias: this.boAlias,
            boData: utils.parseToJson(formDataStr)
          };
          //数据视图控件
          if (this.fillField && this.fillField != "") {
            let fillField = this.fillField;
            data.boData[this.boAlias][fillField] = this.fillValue;
          }
          this.disabled = true;

          if(delDraftId){
            data.delDraftId = delDraftId;
          }
          data.formKey=this.formKey;
          this.$store.dispatch("form/boSave", data).then(result => {
            if (result.state) { 
              let url = window.context.bpmRunTime+"/bpm/haiyaScript/getAndExecuteFormProcedure";
              let data1 = {alias:this.templateKey,id:result.value};
              req.post(url,data1).then(resp=>{
                if(resp.data.state){
                  this.$message.success(result.message);
                  setTimeout(() => {
                    this.close(true);
                  }, 1500);
                }else{
                  this.$message.error('出现异常，请检查数据');
                }
              })
            } else {
              this.disabled = false;
              this.$message.error(result.message);
            }
          });
        })
        .catch((reason) =>
          utils.handleGetFormDataReject(reason)
        );
    },
    boSaveAndDelDraft(){
      this.handleBoSave(this.draftId);
    },
    //保存
    boSaveDraft() {
      utils
        .getOnlineFormData(false)
        .then(formDataStr => {
          let _me = this;
          let data = {
            tempAlias: this.tempAlias,
            dataJson: formDataStr
          };
          if(this.draft){
            data.id = this.draft.id;
          }
          //数据视图控件
          if (this.fillField && this.fillField != "") {
            let fillField = this.fillField;
            data.boData[this.boAlias][fillField] = this.fillValue;
          }
          this.disabled = true;
          this.$store.dispatch("form/boSaveDraft", data).then(result => {
            if (result.state) {
              this.$message.success(result.message);
              this.$router.push("/statement/draftList");
            } else {
              this.disabled = false;
              this.$message.error(result.message);
            }
          });
        })
        .catch((reason) =>
          utils.handleGetFormDataReject(reason)
        );
    },
    //关闭窗口
    close(isDelay) {//数据报表点击关闭按钮
      let _me = this;
      let url = window.location.href;
      let param = url.split("?")[1].split("&");
      if(param.includes("isNewPage=true")){
        window.close();
      }
      if (isDelay === true) {
        setTimeout(function() {
          _me.$router.go(-1);
        }, 2000);
      } else {
        _me.$router.go(-1);
      }
    }
  },
  created() {
    var $ = require("jquery");
    this.id = utils.getUrlKey("id");
    this.startFlow = utils.getUrlKey("startFlow");
    this.recordId = utils.getUrlKey("recordId");
    this.fillField = utils.getUrlKey("fillField");
    this.fillValue = utils.getUrlKey("fillValue");
    this.draftId = utils.getUrlKey("draftId");
    let _me = this;
    let handlerJs = function(rep) {
      const currentUser = _me.$store.state.login.currentUser;
      let data = _me.data;
      eval(rep.diyJs);
    };
    let handler = function() {
      let data = {
        formKey: _me.formKey,
        boAlias: _me.boAlias,
        id: _me.id ? _me.id : "",
        action: _me.action,
        recordId: _me.recordId ? _me.recordId : "",
      };
      _me.$store.dispatch("form/getTemplateForm", data).then(rep => {
        if (rep.result) {
          _me.data = rep.data;
          if (rep.permission) {
            _me.permission = rep.permission;
          }
          _me.html = rep.form.formHtml;
        }
      });
    };
    let editDraftHandler = function() {
      _me.$store.dispatch("form/getTempDraftData", _me.draftId).then(rep => {
        if (rep.result) {
          _me.data = rep.data;
          _me.draft = rep.draft;
          if (rep.permission) {
            _me.permission = rep.permission;
          }
          _me.html = rep.form.formHtml;
        }
      });
    };

    this.$store
      .dispatch("form/getBpmDataTemplateInfo", {
        templateKey: this.templateKey
      })
      .then(result => {
        if (result.state) {
          _me.boAlias = result.value.boDefAlias;
          _me.defKey = result.value.defId;
          _me.formKey = result.value.formKey;
          _me.tempAlias = result.value.alias;
          if (result.value.manageField) {
            let re = JSON.parse(result.value.manageField);
            re.forEach(item => {
              if (item.name == "startFlow") {
                this.startFlow = true;
              }
            });
          } else {
            this.startFlow = true;
          }
          //如果编辑的是草稿数据
          if(this.action === 'editDraft'){
            editDraftHandler();
          }else{
            handler();
          }
        }
      });
  }



};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";


/deep/.el-table--border tr:nth-child(even){
    background: rgb(240, 241, 241);
}

/deep/.el-table--border th,
/deep/.el-table--border td {
  //border-right:1px dashed #000000;
  border-bottom: 1px solid rgb(218, 218, 218);
  border-right: 1px dashed rgb(218, 218, 218);
}



/deep/ .el-table__body tr.hover-row > td,.el-table__body tr.hover-row.current-row > td,.el-table__body tr.hover-row.striped-row > td,.el-table__body tr.hover-row.--striped.current-row > td{
  background-color:#fdfdaf !important;
}


/deep/.el-table--small th,
/deep/ .el-table--small td {
  padding: 1px 0;
}

/deep/ .el-table .todo-row{
  height: 41px;
}

/deep/ .el-table th.todo-header-row{
  height: 44px;
  text-align: center;
  color: #000000;
  background: #e6e6e6;
  font-size: 14px;
}

/deep/.el-table .cell {
  padding-left: 0px;
  padding-right: 0px;
  line-height: unset;
}


/deep/.el-table .cell,
/deep/.todo-subject,
/deep/.el-tooltip > span {
  font-size: 12px !important;
}

/deep/.el-form-item {
    margin-bottom: 15px !important;
    margin-top: 10px !important;
    margin-right : 10px !important;
}
.base-main {
  background-color: #e9eef3;
  height: 100%;
}

/deep/ .form-table {
  width: 100%;
  border-top: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
}

/deep/ .form-table > thead > tr > th, /deep/ .form-table > tbody > tr > th {
  text-align: right;
  color: #666;
  font-weight: normal;
}

/deep/ .form-table > tbody > tr > th.group-th {
  text-align: left;
  background: #f9f9f9;
  font-weight: bold;
}

/deep/ .form-table > thead > tr.sub-table-header > th {
  text-align: center;
}

/deep/ .form-table > tbody > tr > th > span, /deep/ .form-table > thead > tr > th > span {
  color: #f00;
}

/deep/ .form-table > tbody > tr > th, /deep/ .form-table > tbody > tr > td, /deep/ .form-table > tfoot > tr > td, /deep/ .form-table > thead > tr > th {
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  padding: 10px;
  min-width: 0;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
}

/deep/ .form-table > tfoot > tr > td {
  padding: 5px 10px;
}

.form-container {
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}

.form-container > span {
  border-left: 3px solid $--theme-color;
  font-weight: bold;
  font-size: 14px;
  padding-left: 10px;
  color: #666;
}

.form-content {
  padding: 11px 0;
}

/deep/ div[aria-invalid='true'] + small, /deep/ small.error-message {
  display: block;
  margin-top: 8px;
  color: #f56c6c;
  font-size: 12px;
  font-weight: bold;
  line-height: 1;
}
</style>
